import { render } from "./StudentTraining.vue?vue&type=template&id=5e6f1d29&scoped=true"
import script from "./StudentTraining.vue?vue&type=script&lang=js"
export * from "./StudentTraining.vue?vue&type=script&lang=js"

import "./StudentTraining.vue?vue&type=style&index=0&id=5e6f1d29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6f1d29"]])

export default __exports__